import React from 'react';
import { SvgIcon } from '@material-ui/core';

const TvIcon = (props) => {
  return (
      <img class="homeicon" viewBox="0 0 24 24" src="./images/tv.svg" alt="" />
  );
};

export default TvIcon;
